export const KALTURA_VIDEO_INIT =
  'https://www.kaltura.com/api_v3/service/session/action/start';
export const KALTURA_VIDEO_DATA_API =
  'https://www.kaltura.com/api_v3/service/baseentry/action/get';
